var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 288,
    viewBox: "0 0 161 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.38672 61.1382L4.38672 104.783H7.11928L7.11928 61.1382H4.38672Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9902 61.1382L21.9902 104.783H24.7228L24.7228 61.1382H21.9902Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1885 -0.00531006L13.1885 43.6396H15.921L15.921 -0.00531006H13.1885Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1367 218.192V270.522H81.8693V218.192H79.1367Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1367 148.364V200.694H81.8693V148.364H79.1367Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1367 78.6152V130.945H81.8693V78.6152H79.1367Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1367 8.87202V61.2021H81.8693V8.87202H79.1367Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36328 122.239L1.36328 165.83H27.7403L27.7403 122.239H1.36328Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1885 183.254L13.1885 226.899H15.921L15.921 183.254H13.1885Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 183.254L0 226.899H2.73256L2.73256 183.254H0Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.377 183.254L26.377 226.899H29.1095L29.1095 183.254H26.377Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1885 244.355L13.1885 288H15.921L15.921 244.355H13.1885Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 244.355L0 288H2.73256L2.73256 244.355H0Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.377 244.355L26.377 288H29.1095L29.1095 244.355H26.377Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7539 244.355L52.7539 288H55.4865L55.4865 244.355H52.7539Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5654 244.355L39.5654 288H42.298L42.298 244.355H39.5654Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.88 61.1382V104.783H156.612V61.1382H153.88Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.277 61.1382V104.783H139.01V61.1382H136.277Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.079 -0.00531006V43.6396H147.812V-0.00531006H145.079Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.26 122.239V165.83H159.637V122.239H133.26Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.079 183.254V226.899H147.812V183.254H145.079Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.268 183.254V226.899H161V183.254H158.268Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.891 183.254V226.899H134.623V183.254H131.891Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.079 244.355V288H147.812V244.355H145.079Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.268 244.355V288H161V244.355H158.268Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.891 244.355V288H134.623V244.355H131.891Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.514 244.355V288H108.246V244.355H105.514Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.702 244.355V288H121.435V244.355H118.702Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 161,
    fill: "white",
    transform: "translate(0 288) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset2);
export default __webpack_public_path__ + "static/media/asset2.fea1f9c3d5083b1948277a3dbed78640.svg";
export { ForwardRef as ReactComponent };